// --- AddToMultipleVendorsModal.js ---
import React from 'react';
import { Modal, Button, Form, ListGroup } from 'react-bootstrap';

const AddToMultipleVendorsModal = ({
  show,
  onHide,
  vendors,
  onConfirm,
  selectedVendorIds,
  setSelectedVendorIds
}) => {
  const handleCheckboxChange = (vendorId) => {
    if (selectedVendorIds.includes(vendorId)) {
      setSelectedVendorIds(selectedVendorIds.filter((id) => id !== vendorId));
    } else {
      setSelectedVendorIds([...selectedVendorIds, vendorId]);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="md" centered>
      <Modal.Header closeButton>
        <Modal.Title>➕ Add Event to Other Vendors</Modal.Title>
      </Modal.Header>
     <Modal.Body>
  {Array.isArray(vendors) && vendors.length > 0 ? (
    <Form>
      {vendors.map((vendor) => (
        <Form.Check
          key={vendor.id}
          type="checkbox"
          label={vendor.title}
          checked={selectedVendorIds.includes(vendor.id)}
          onChange={() => handleCheckboxChange(vendor.id)}
        />
      ))}
    </Form>
  ) : (
    <div className="text-muted">No vendors available to add.</div>
  )}
</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Cancel</Button>
        <Button variant="primary" onClick={onConfirm} disabled={selectedVendorIds.length === 0}>
          ✅ Confirm & Add
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddToMultipleVendorsModal;
